// /admin/knowledge* Wrapper — alle Endpoints Owner-only (siehe api/src/routes/admin.ts).
// Deckt ab: Knowledge-Video-Liste, Sync-Trigger, Agent-Assignment pro Video.

import { apiFetch } from './api';

export interface KnowledgeVideo {
  videoId: string;
  videoName: string | null;
  chunks: number;
  active: number;
  agentKeys: string[];
}

export interface KnowledgeSyncResult {
  ok: boolean;
  fetched: number;
  upserted: number;
  deleted: number;
  skipped?: boolean;
  message?: string;
}

export function fetchKnowledgeVideos(accessToken: string): Promise<KnowledgeVideo[]> {
  return apiFetch<KnowledgeVideo[]>('/admin/knowledge', { accessToken });
}

export function syncKnowledge(accessToken: string): Promise<KnowledgeSyncResult> {
  return apiFetch<KnowledgeSyncResult>('/admin/knowledge/sync', {
    method: 'POST',
    accessToken,
  });
}

export interface SetKnowledgeAssignmentInput {
  videoId: string;
  agentKeys: string[];
}

export function setKnowledgeAssignment(
  accessToken: string,
  input: SetKnowledgeAssignmentInput,
): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/admin/knowledge/assignment', {
    method: 'PUT',
    accessToken,
    json: input,
  });
}
